/*
  ves-free-pack.js

  Opens the Free Starter Pack capture modal (snippets/ves-free-pack-modal.liquid)
  from any on-site "Free starter pack" link, instead of navigating away. The
  form inside sends the signup to MailerLite by form id and READS MailerLite's
  answer (2026-10-01): success shows the confirm message, an error shows a clear
  message and lets the visitor try again. The visitor id and the UTMs ride along
  as fields.

  Triggers (delegated, so it covers header / footer / mobile drawer / inline):
    - any element with [data-ves-freepack]
    - any link whose href points at the free-pack page (/pages/free-pack)

  Close: the × button, the backdrop, or Esc (native <dialog>).
*/
(function () {
  'use strict';

  function getModal() {
    return document.getElementById('ves-free-pack-modal');
  }

  function openModal() {
    var m = getModal();
    if (!m) return;
    if (typeof m.showModal === 'function') {
      if (!m.open) m.showModal();
    } else {
      m.setAttribute('open', '');
    }
    document.documentElement.classList.add('ves-fp-open');
    // Focus the email field once MailerLite has rendered the form.
    setTimeout(function () {
      var input = m.querySelector('input[type="email"], input[type="text"]');
      if (input) {
        try { input.focus(); } catch (e) {}
      }
    }, 60);
  }

  function closeModal() {
    var m = getModal();
    if (!m) return;
    if (m.open && typeof m.close === 'function') m.close();
    else m.removeAttribute('open');
    document.documentElement.classList.remove('ves-fp-open');
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    // Open: free-pack trigger links. The modal is the canonical on-site
    // capture, so plain /pages/free-pack links open it too, but:
    //  - modified clicks (cmd/ctrl/shift/alt, non-primary button) keep their
    //    native behavior (new tab etc.) instead of being swallowed;
    //  - if the modal isn't in the DOM for any reason, fall through to the
    //    normal navigation rather than dead-ending the click.
    var trigger = e.target.closest('[data-ves-freepack], a[href*="/pages/free-pack"]');
    if (trigger) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      if (!getModal()) return;
      e.preventDefault();
      openModal();
      return;
    }

    // Close: × button.
    if (e.target.closest('[data-ves-freepack-close]')) {
      e.preventDefault();
      closeModal();
      return;
    }

    // Close: click on the dialog backdrop (the dialog element itself, outside
    // its inner card).
    var m = getModal();
    if (m && m.open && e.target === m) {
      closeModal();
    }
  });

  // Native <dialog> fires `close` on Esc; keep the html flag in sync.
  document.addEventListener('close', function (e) {
    if (e.target && e.target.id === 'ves-free-pack-modal') {
      document.documentElement.classList.remove('ves-fp-open');
    }
  }, true);

  // Capture form (homepage block + this modal share snippets/ves-capture-block).
  // Since 2026-10-01 the signup is sent with fetch (GET, ajax=1, the same call
  // MailerLite's own embed script makes; assets.mailerlite.com answers with
  // access-control-allow-origin: *) and the answer is READ: {success:true}, or
  // {success:false, errors:{fields:{email:[...]}}}. Before, the form posted into a
  // hidden iframe and always showed "check your inbox" 150 ms later, even when
  // MailerLite had rejected the signup. Native type=email + required validation
  // still gates the submit event (the form intentionally has no novalidate).
  var MSG_OK = 'Check your inbox and click Confirm to get your free pack.';
  var MSG_FIELD = 'That did not work. Check your email address and try again.';
  var MSG_RETRY = 'That did not work. Please try again in a moment.';
  var TIMEOUT_MS = 10000;
  var TYPOS = {
    'gmial.com': 'gmail.com', 'gmal.com': 'gmail.com', 'gamil.com': 'gmail.com', 'gmai.com': 'gmail.com',
    'gmail.co': 'gmail.com', 'gmail.con': 'gmail.com', 'gnail.com': 'gmail.com',
    'hotmal.com': 'hotmail.com', 'hotmial.com': 'hotmail.com', 'hotmai.com': 'hotmail.com', 'hotmail.con': 'hotmail.com',
    'yaho.com': 'yahoo.com', 'yahooo.com': 'yahoo.com', 'yahoo.con': 'yahoo.com',
    'outlok.com': 'outlook.com', 'outloook.com': 'outlook.com', 'outlook.con': 'outlook.com',
    'icloud.con': 'icloud.com'
  };

  // One status line under the form (errors) and one under the field (typo hint).
  function statusEl(form, kind) {
    var cls = 'ves-try__' + kind;
    var el = form.parentNode.querySelector('.' + cls);
    if (!el) {
      el = document.createElement('p');
      el.className = cls;
      el.style.cssText = 'margin:8px 0 0;font-size:13px;line-height:1.4;' + (kind === 'error' ? 'color:#ff6b6b;' : 'opacity:.85;');
      if (kind === 'error') el.setAttribute('role', 'alert');
      el.hidden = true;
      form.parentNode.insertBefore(el, form.nextSibling);
    }
    return el;
  }

  function showError(form, text) {
    var el = statusEl(form, 'error');
    el.textContent = text;
    el.hidden = false;
  }

  function checkTypo(form) {
    var input = form.querySelector('input[type="email"]');
    var hint = statusEl(form, 'hint');
    var v = input ? String(input.value || '').trim() : '';
    var at = v.lastIndexOf('@');
    var fix = at > 0 ? TYPOS[v.slice(at + 1).toLowerCase()] : '';
    hint.textContent = '';
    hint.hidden = true;
    if (!fix) return;
    var good = v.slice(0, at + 1) + fix;
    hint.appendChild(document.createTextNode('Did you mean ' + good + '? '));
    var b = document.createElement('button');
    b.type = 'button';
    b.textContent = 'Use ' + fix;
    b.style.cssText = 'background:none;border:0;padding:0;color:inherit;text-decoration:underline;cursor:pointer;font:inherit;';
    b.addEventListener('click', function () {
      input.value = good;
      hint.hidden = true;
      try { input.focus(); } catch (e) {}
    });
    hint.appendChild(b);
    hint.hidden = false;
  }

  document.addEventListener('input', function (e) {
    var f = e.target && e.target.closest && e.target.closest('[data-ves-capture-form]');
    if (f && e.target.type === 'email') {
      var h = f.parentNode.querySelector('.ves-try__hint');
      if (h) { h.hidden = true; }
    }
  });
  document.addEventListener('focusout', function (e) {
    var f = e.target && e.target.closest && e.target.closest('[data-ves-capture-form]');
    if (f && e.target.type === 'email') checkTypo(f);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-ves-capture-form]')) return;

    // Re-entry guard: one POST per form. Rapid double-clicks/Enter before the
    // swap lands would otherwise fire duplicate subscribes.
    if (form.dataset.vesSubmitted === '1') {
      e.preventDefault();
      return;
    }
    form.dataset.vesSubmitted = '1';
    // We send the signup ourselves (below) so we can read the answer.
    e.preventDefault();
    var errEl = form.parentNode.querySelector('.ves-try__error');
    if (errEl) errEl.hidden = true;

    // Attach the visitor's quiz profile (if they took the quiz) as
    // MailerLite fields so leads arrive pre-segmented. Runs before the
    // browser serializes the form, so the hidden inputs are included.
    try {
      var qp = JSON.parse(localStorage.getItem('ves_quiz_profile') || 'null');
      if (qp) {
        [['quiz_profile', qp.q1], ['quiz_work', qp.q2], ['quiz_experience', qp.q3], ['quiz_pain', qp.q4], ['quiz_match', qp.match]].forEach(function (kv) {
          if (!kv[1]) return;
          var name = 'fields[' + kv[0] + ']';
          if (form.querySelector('[name="' + name + '"]')) return;
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = kv[1];
          form.appendChild(input);
        });
      }
    } catch (err) { /* enrichment is best-effort */ }

    // Attribution at signup (2026-09-22, docs/SIGNUP_ID_SETUP.md): the capture
    // snippet (ves-capture) keeps the visitor id and the first/last touch in
    // cookies and localStorage; send them as MailerLite fields so the signup
    // ties the visitor to the email on day one and carries the UTMs that
    // brought them. MailerLite's own "Collect UTM parameters" switch only
    // works on its embeds, never on this form. Best-effort, never blocks.
    try {
      var readCk = function (name) {
        try {
          var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
          if (m) return decodeURIComponent(m[1]);
        } catch (e1) {}
        try { return localStorage.getItem(name) || ''; } catch (e2) { return ''; }
      };
      var parseT = function (s) { try { var v = JSON.parse(s || 'null'); return v && typeof v === 'object' ? v : null; } catch (e3) { return null; } };
      var aid = String(readCk('_ves_aid') || '').toLowerCase();
      var lt = parseT(readCk('_ves_lt')), ft = parseT(readCk('_ves_ft'));
      var t = (lt && (lt.src || lt.med || lt.cmp || lt.cnt)) ? lt : ft;
      var pairs = [['ves_aid', /^[0-9a-f]{16}$/.test(aid) ? aid : '']];
      if (t) pairs.push(['utm_source', t.src], ['utm_medium', t.med], ['utm_campaign', t.cmp], ['utm_content', t.cnt]);
      pairs.forEach(function (kv) {
        if (!kv[1]) return;
        var name = 'fields[' + kv[0] + ']';
        var existing = form.querySelector('[name="' + name + '"]');
        if (existing) { existing.value = kv[1]; return; }
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = String(kv[1]).slice(0, 200);
        form.appendChild(input);
      });
    } catch (err) { /* attribution is best-effort */ }
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;

    var settled = false;
    var ctl = (typeof AbortController === 'function') ? new AbortController() : null;
    var timer = null;

    // Re-open the form after a failure: keep what was typed, allow a new try.
    function fail(text) {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      form.dataset.vesSubmitted = '';
      if (btn) btn.disabled = false;
      showError(form, text);
    }

    // closest() keeps the lookup stable if the form ever gains a wrapper;
    // focusing the status box (a) lands keyboard users on it and (b) pairs with
    // its role=status announcement for screen readers.
    function succeed() {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      var wrap = form.closest('.ves-try__content') || form.parentElement;
      var success = wrap && wrap.querySelector('[data-ves-capture-success]');
      var hint = form.parentNode.querySelector('.ves-try__hint');
      if (hint) hint.hidden = true;
      form.hidden = true;
      if (success) {
        var txt = success.querySelector('span');
        if (txt) txt.textContent = MSG_OK;
        success.hidden = false;
        try { success.focus({ preventScroll: true }); } catch (err) {}
      }
    }

    try {
      var params = new URLSearchParams(new FormData(form));
      params.set('ajax', '1');
      params.set('_', String(Date.now())); // the endpoint is cached 180 s per URL
      timer = window.setTimeout(function () {
        if (ctl) { try { ctl.abort(); } catch (e2) {} }
        fail(MSG_RETRY);
      }, TIMEOUT_MS);
      fetch(form.getAttribute('action') + '?' + params.toString(), { method: 'GET', signal: ctl ? ctl.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.success === true) { succeed(); return; }
          var fe = d && d.errors && d.errors.fields;
          if (fe && Object.keys(fe).length) { fail(MSG_FIELD); return; }
          fail(MSG_RETRY);
        })
        .catch(function () { fail(MSG_RETRY); });
    } catch (err) {
      fail(MSG_RETRY);
    }
  });
})();
